import BaseModel from "./BaseModel"
import { Moment } from "moment-timezone"

export default class NtsEvent extends BaseModel {
  id: number
  createdAt: Moment
  updatedAt: Moment
  cancelledAt: Moment
  date: Moment
  timezone: string
  zoomMeetingInfo: string
  numberOfMembers: number

  getCasts () {
    return {
      id: 'number',
      createdAt: 'datetime',
      updatedAt: 'datetime',
      cancelledAt: 'datetime',
      date: 'datetime',
    }
  }
}
